import React from 'react';
import { useIonAlert } from '@ionic/react';

type PresentAlert = ReturnType<typeof useIonAlert>[0];

/** Same as Ionic's useIonAlert, but the default dismiss button reads "Okay". */
export const useAlert = (): [PresentAlert, () => Promise<void>] => {
	const [present, dismiss] = useIonAlert();
	const presentAlert = React.useCallback(
		(messageOrOptions: any, buttons?: any) =>
			typeof messageOrOptions === 'string'
				? present(messageOrOptions, buttons ?? [{ text: 'Okay' }])
				: present(messageOrOptions),
		[present]
	);
	return [presentAlert as PresentAlert, dismiss];
};
